import React from 'react';
import { func, number } from 'prop-types';

import css from './SeoDiscovery.module.css';

const SeoIndexPagination = props => {
  const { currentPage, getPageHref, pageSize, total } = props;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  if (totalPages <= 1) {
    return null;
  }

  const pages = [];
  for (let page = 1; page <= totalPages; page += 1) {
    pages.push(page);
  }

  return (
    <nav className={css.indexPagination} aria-label="Pagination">
      {currentPage > 1 ? (
        <a href={getPageHref(currentPage - 1)} rel="prev">
          Previous
        </a>
      ) : null}
      <span className={css.indexPaginationPages}>
        {pages.map(page => (
          <a
            key={page}
            href={getPageHref(page)}
            aria-current={page === currentPage ? 'page' : undefined}
          >
            {page}
          </a>
        ))}
      </span>
      {currentPage < totalPages ? (
        <a href={getPageHref(currentPage + 1)} rel="next">
          Next
        </a>
      ) : null}
    </nav>
  );
};

SeoIndexPagination.propTypes = {
  currentPage: number.isRequired,
  getPageHref: func.isRequired,
  pageSize: number.isRequired,
  total: number.isRequired,
};

export default SeoIndexPagination;
